import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'gatsby'
import { useFlexSearch } from 'react-use-flexsearch'
import { motion, AnimatePresence } from 'framer-motion'
import { ProductSearchForm } from './form/ProductSearchForm'
import { useProductSearchStore } from '/src/hooks'

import './header_product_search.scss'

const variantsBoxContainer = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  }
}

const variantBox = {
  hidden: { opacity: 0, top: -100 },
  show: { opacity: 1, top: 0 }
}

const hasResults = (values) => values.length !== 0

const SearchResults = ({ results }) => {
  const listClasses = ['search-result-list']
  if (hasResults(results)) listClasses.push('active')

  return (
    <motion.ul className={listClasses.join(' ')}>
      {results.map((result) => {
        return (
          <motion.li
            key={result.id}
            variants={variantBox}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="search-result-list-item">
            <Link to={result.path}>
              <label>{result.title}</label>
              <span>{result.type}</span>
            </Link>
          </motion.li>
        )
      })}
    </motion.ul>
  )
}

export default () => {
  const { store, index } = useProductSearchStore()
  const [query, setQuery] = useState(null)
  const results = useFlexSearch(query, index, store, {
    tokenize: 'full'
  })

  return (
    <Row className="product-search-row">
      <ProductSearchForm setQuery={setQuery} />
      <Col xs={12}>
        <AnimatePresence>
          <motion.div
            key="search-results-motion"
            className="search-result-group"
            variants={variantsBoxContainer}
            initial="hidden"
            animate="show"
            exit="hidden">
            <SearchResults results={results} />
          </motion.div>
        </AnimatePresence>
      </Col>
    </Row>
  )
}
